function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8.292 6.069a1.62 1.62 0 001.625-1.614 1.62 1.62 0 00-1.625-1.614 1.62 1.62 0 00-1.625 1.614A1.62 1.62 0 008.292 6.07zM8.292 10.414A1.62 1.62 0 009.917 8.8a1.62 1.62 0 00-1.625-1.613A1.62 1.62 0 006.667 8.8a1.62 1.62 0 001.625 1.614zM8.292 14.758a1.62 1.62 0 001.625-1.613 1.62 1.62 0 00-1.625-1.614 1.62 1.62 0 00-1.625 1.614 1.62 1.62 0 001.625 1.613z",
  fill: "#000"
}));